import type { ActionToast, ToastTone } from "./use-user-action-toast";

interface UserActionToastProps {
  readonly toast: ActionToast | null;
}

/** Inline result banner of a user-detail action, keyed by tone for the tests. */
export function UserActionToast({ toast }: UserActionToastProps) {
  if (!toast) return null;
  return (
    <div data-testid={`user-action-toast-${toast.tone}`} className={toastClass(toast.tone)}>
      {toast.message}
    </div>
  );
}

function toastClass(tone: ToastTone): string {
  const base = "rounded-md border px-3 py-2 font-sans text-sm font-medium";
  if (tone === "success") {
    return `${base} border-emerald-300/40 bg-emerald-50 text-emerald-800`;
  }
  if (tone === "warning") {
    return `${base} border-amber-500/30 bg-amber-500/10 text-amber-900 dark:text-amber-200`;
  }
  return `${base} border-destructive/30 bg-destructive/5 text-destructive`;
}
